// src/Auth/AuthorizeRoute.tsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthContext } from "./AuthProvider";

type Props = { children: React.ReactNode };

export const AuthorizeRoute: React.FC<Props> = ({ children }) => {
    const auth = React.useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        let alive = true;

        (async () => {
            // Wait for AuthService to restore session (MSAL or native)
            await auth.onReady?.();

            if (auth.isAuthenticated()) {
                if (alive) setChecked(true);
                return;
            }

            // Not authenticated → remember target and send to /prelogin
            const current = location.pathname + location.search + location.hash;
            try {
                localStorage.setItem("redirectUri", current || "/");
            } catch {
                // ignore
            }

            // BrowserRouter has basename=/precert, so we navigate to /prelogin
          //  navigate("/prelogin", { replace: true });
        })();

        return () => {
            alive = false;
        };
    }, [auth, location, navigate]);

    if (!checked) return <AbpnSpinner />;

    return <>{children}</>;
};

export default AuthorizeRoute;
